/**
 * Work-email input for signup / login.
 * When admin has active email domains, shows local-part + @domain dropdown.
 * Otherwise falls back to a single free-text email field.
 */
export function buildEmailAddress({ email, emailLocal, emailDomain, enforceDomain }) {
    if (!enforceDomain) return String(email || '').trim().toLowerCase();
    const local = String(emailLocal || '').trim().replace(/[@\s]/g, '').toLowerCase();
    const domain = String(emailDomain || '').trim().replace(/^@+/, '').toLowerCase();
    if (!local || !domain) return '';
    return `${local}@${domain}`;
}

export default function EmailDomainField({
    label = 'Email',
    enforceDomain = false,
    domainOptions = [],
    email = '',
    emailLocal = '',
    emailDomain = '',
    onChange,
    required = false,
    hint,
    placeholder,
    autoComplete,
}) {
    if (enforceDomain && domainOptions.length > 0) {
        return (
            <div>
                <label className="ag-label">{label}{required ? ' *' : ''}</label>
                <div className="flex gap-2 items-stretch">
                    <input
                        className="ag-input flex-1 min-w-0"
                        type="text"
                        inputMode="email"
                        autoComplete={autoComplete || 'username'}
                        required={required}
                        value={emailLocal}
                        placeholder={placeholder || 'you'}
                        onChange={e => onChange({ emailLocal: e.target.value })}
                    />
                    <span className="flex items-center text-ink-500 font-medium px-1">@</span>
                    <select
                        className="ag-input w-[min(45%,220px)] shrink-0"
                        required={required}
                        value={emailDomain}
                        onChange={e => onChange({ emailDomain: e.target.value })}
                    >
                        {domainOptions.map(d => (
                            <option key={d.slug} value={d.slug}>{d.label || d.slug}</option>
                        ))}
                    </select>
                </div>
                {hint && <div className="text-[11px] text-ink-500 mt-1">{hint}</div>}
            </div>
        );
    }

    return (
        <div>
            <label className="ag-label">{label}{required ? ' *' : ''}</label>
            <input
                className="ag-input"
                type="email"
                autoComplete={autoComplete || 'username'}
                required={required}
                value={email}
                placeholder={placeholder || 'you@yourcompany.com'}
                onChange={e => onChange({ email: e.target.value })}
            />
            {hint && <div className="text-[11px] text-ink-500 mt-1">{hint}</div>}
        </div>
    );
}
